import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgLockIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="lock_svg__nc-icon-wrapper">
      <circle cx={32} cy={38} r={2} />
      <path d="m56.242 8.031-24-6a.968.968 0 0 0-.484 0l-24 6A1 1 0 0 0 7 9v28a25 25 0 0 0 50 0V9a1 1 0 0 0-.758-.969ZM25 23a7 7 0 0 1 14 0v5h-2v-5a5 5 0 0 0-10 0v5h-2Zm18 22a1 1 0 0 1-1 1H22a1 1 0 0 1-1-1V31a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1Z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgLockStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgLockIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const LockIcon: any = SvgLockStyle;
export default LockIcon;
